import { Stack } from "@mui/material";
import { RoundingUnitKind } from "@sinch/core/entities/serverEnums";
import { mergeDeepRight } from "ramda";
import React from "react";
import {
  IntervalAdvancedOptions,
  IntervalAdvancedOptionsValue,
} from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/IntervalSelect/IntervalPopover/IntervalAdvancedOptions";
import { MinimumHoursInput } from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/IntervalSelect/IntervalPopover/MinimumHoursInput";
import {
  type AnyUnitName,
  roundingKindOfUnit,
  RoundingInput,
} from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/IntervalSelect/IntervalPopover/RoundingInput";

export type IntervalAdditionalSettingsValue = IntervalAdvancedOptionsValue & {
  minimum: { amount: number };
};

export const IntervalAdditionalSettings = ({
  onChange,
  value,
  unitName,
}: {
  value: IntervalAdditionalSettingsValue;
  onChange: (val: IntervalAdditionalSettingsValue) => void;
  unitName: AnyUnitName;
}) => {
  const modifyVal = mergeDeepRight(value ?? {});

  if (roundingKindOfUnit(unitName) === RoundingUnitKind.Distance) {
    return (
      <Stack data-cy="IntervalSelect-additionalSettings">
        <RoundingInput onChange={(val) => onChange(modifyVal({ roundingId: val }))} unitName={unitName} value={value?.roundingId ?? null} />
      </Stack>
    );
  }

  return (
    <Stack data-cy="IntervalSelect-additionalSettings">
      <MinimumHoursInput
        onChange={(amount) => onChange(modifyVal({ minimum: { amount } }))}
        value={value?.minimum.amount}
      />
      <IntervalAdvancedOptions
        hasMinHours={value?.minimum.amount !== 0}
        onChange={(val): void => {
          onChange(modifyVal({ minimum: { ...val.minimum }, unit: { ...val.unit }, roundingId: val.roundingId }));
        }}
        unitName={unitName}
        value={value}
      />
    </Stack>
  );
};
